export const generateDates = (days: number) =>  {
    return Array.from({
        length: days
    }, (_, i) =>
        new Date(Date.now() - i * 86400000).toISOString().split("T")[0]
    );
};

export const generateDatesFuture = (days: number) =>  {
    return Array.from({
        length: days
    }, (_, i) =>
        new Date(Date.now() + i * 86400000).toISOString().split("T")[0]
    );
};
